import { DataSearchType } from './type'

const CHILDREN_QUERY_KEYS = ['number_of_study_abroad', 'number_of_preschoolers_1', 'number_of_students_1', 'birthdays'] as const

// LP のベースパスを取り出す
export const buildLpBasePath = (pathname: string): string => {
  const path = pathname.replace(/\/+$/, '')
  const lpBasePathRegex =
    /^(\/(?:destination|preschool)\/[^/]+\/[^/]+\/[^/]+|\/(?:lp_preview|jpe_lp_preview)\/[^/]+)(?:\/[^/]+)?$/
  const match = path.match(lpBasePathRegex)
  return match?.[1] ?? path
}

export const buildCheckInDateUrl = (pathname: string): string => `${buildLpBasePath(pathname)}/availability/check_in_dates`

export const buildAvailabilityUrl = (pathname: string): string => `${buildLpBasePath(pathname)}/availability`

export const buildLastMinuteInquiryUrl = (pathname: string): string =>
  `${buildLpBasePath(pathname)}/availability/last_minute_inquiries`
// [issue#2436] 滞在期間フォールバックのループガード用パラメータ。検索条件ではないため、
// ユーザーが条件を変更して URL を組み立て直すときは捨てる（残したままにすると、後のリロードや
// URL 共有時にサーバ側の候補選定から古い stay_day が誤って除外され続ける）。
export const FALLBACK_GUARD_QUERY_KEYS = ['stay_day_tried'] as const

export const deleteFallbackGuardParams = (params: URLSearchParams): URLSearchParams => {
  FALLBACK_GUARD_QUERY_KEYS.forEach((key) => params.delete(key))
  return params
}

type CheckInDateParamsDefaults = Pick<DataSearchType, 'number_of_adults' | 'stay_day'>

export type CheckInDateParams = {
  number_of_adults: string
  stay_day: string
  number_of_study_abroad?: string
  number_of_preschoolers_1?: string
  number_of_students_1?: string
  birthdays?: string
}

// LP 空き状況ページの check_in_dates / availability.json API に送る
// 検索条件パラメータを URL の query から組み立てる。
// こども関連パラメータは URL に1つも無い場合は送らず、サーバ側のデフォルト
// （サービスタイプに応じた1人）に委ねる (issue #1614)
export const buildCheckInDateParams = (search: string, defaults: CheckInDateParamsDefaults): CheckInDateParams => {
  const query = new URLSearchParams(search)
  const queryParams = Object.fromEntries(query.entries())
  const hasUrlChildrenParams = CHILDREN_QUERY_KEYS.some((key) => query.has(key))

  return {
    number_of_adults: queryParams.number_of_adults || String(defaults.number_of_adults),
    stay_day: queryParams.stay_day || defaults.stay_day,
    ...(hasUrlChildrenParams
      ? {
          number_of_study_abroad: queryParams.number_of_study_abroad || '0',
          number_of_preschoolers_1: queryParams.number_of_preschoolers_1 || '0',
          number_of_students_1: queryParams.number_of_students_1 || '0',
          birthdays: queryParams.birthdays || '',
        }
      : {}),
  }
}
